function nope(..._args: any[]) {
    /* do nothing */
}

export class Deferred {
    public promise: Promise<any>;
    public resolve = nope;
    public reject = nope;

    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
